import React, { useState, useEffect } from "react";
import DashboardHeaderStats from "../components/dashbord-new/dashboardHeaderStats";
import { annualViewTabs as AnnualViewTabsStyle } from "../css/styles/componentStyles";
import BudgetStatsCards from "../components/dashbord-new/budgetStatsCard";
import DashboardBudgetChart from "../components/dashbord-new/dashboardBudgetChart";
import DateFilterSelect from "../../../../../../CustomDatePicker/DateFilterSelectold";
import moment from "moment";
import Loader from '../../../../../../presentationals/Loader/Loader.component'
import { useSelector, useDispatch } from 'react-redux';
import { FILTER_ACTION } from '../../../../../../../reducers/CommonFilters.reducer';
import { getExpenseOverviewByDateRangeFilters,getExpenseTableByDateRangeFilters,getExpenseDASHboardsummaryByDateRangeFilters, getExpenseExpectedIncomeByDateRangeFilters } from "../utils/ActionCreator";

function DashboardView() {
  const dispatch = useDispatch();
  const { fromDate, toDate } = useSelector(state => state.FilterReduce.commonFilters);
  const [dateFilterPopup, setDateFilterPopup] = useState({ from: fromDate, to: toDate })
  const [accured, setAccured] = useState("")
  const [loader, setLoader] = useState(false)
  const [apiData, setApiData] = useState({ api1: {},api2:[],api3:{},api4:[] })

  const handleDateFilterPopup = (type, val) => {
    setDateFilterPopup((prev) => ({ ...prev, [type]: val }));
    const formatted = moment(val).format("YYYY-MM-DD");

    setDateFilterPopup((prev) => {
      if (prev[type] === formatted) return prev;

      return {
        ...prev,
        [type]: formatted
      };
    });
    if (type === "from") {
      if (fromDate !== formatted) {
        dispatch({ type: FILTER_ACTION, payload: { "fromDate": formatted } });
      }
    } else {
      if (toDate !== formatted) {
        dispatch({ type: FILTER_ACTION, payload: { "toDate": formatted } });
      }
    }
  }

  useEffect(() => {
    if (
      fromDate !== dateFilterPopup.from ||
      toDate !== dateFilterPopup.to
    ) {
      setDateFilterPopup((prev) => ({
        ...prev,
        from: fromDate,
        to: toDate
      }));
    }
    const obj = { from: fromDate, to: toDate, accured: accured }
    MainApi(obj);
  }, [fromDate, toDate, accured]);


  const MainApi = (data) => {
    setLoader(true)
    getExpenseOverviewByDateRangeFilters(data?.from, data?.to, data?.accured ?? false, callback => {
      setApiData((prev) => ({
        ...prev,
        api1: callback ?? {}
      }))
    })
    getExpenseTableByDateRangeFilters(data?.from, data?.to, callback => {
      setApiData((prev) => ({
        ...prev,
        api2: callback ?? []
      }))
    })
    getExpenseDASHboardsummaryByDateRangeFilters(data?.from, data?.to, callback => {
      setApiData((prev) => ({
        ...prev,
        api3: callback ?? []
      }))
    })
    getExpenseExpectedIncomeByDateRangeFilters(data?.from, data?.to, callback => {
      setApiData((prev) => ({
        ...prev,
        api4: callback ?? []
      }))
    })
    setLoader(false)
  }

  return (
    <>
      {loader ? <Loader /> : ""}
      <div style={AnnualViewTabsStyle.container}>
        <div style={{ background: "#fff",
        //  border: "1px solid rgb(217, 217, 217)",
          padding: '10px', borderRadius: '8px', margin: "0 24px", 
          // boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)" 
          boxShadow: "rgb(179, 179, 179) 0px 2px 8px -1px",
          marginBottom:'10px'
          }}>
          <div className="row">
            <div className=" col-xs-12" style={{ display: 'flex', gap: "15px" }}>
              <DateFilterSelect
                value={[new Date(dateFilterPopup.from), new Date(dateFilterPopup.to)]}
                onChange={(range) => {
                  handleDateFilterPopup("from", range[0]);
                  handleDateFilterPopup("to", range[1]);
                }}
                isFilterCleared={false}
              />
              <select value={accured} onChange={(e) => setAccured(e.target.value)} style={{ border: "1px solid rgb(204, 204, 204)", borderRadius: "8px", padding: "4px 10px" }}>
                <option value={""}>Select Accurred</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>


          </div>
        </div>
        <div style={AnnualViewTabsStyle.tabContainer}>
          <DashboardHeaderStats apiData={apiData} />
          <BudgetStatsCards apiData={apiData}/>
        </div>
      </div>
      <DashboardBudgetChart apiData={apiData} />
    </>
  );
}

export default DashboardView;
